module.exports = __webpack_public_path__ + "static/media/appStoreQRCode.b894906c.svg";